import * as d3 from 'd3';
import store from '@/store/store'

export function xAxisLabel () {
  var x_axis_labels = {
    "This Week": "Date",
    "Last Week": "Date",
    "Last 7 Days": "Date",
    "Last 30 Days": "Date",
    "Year To Date": "Month",
    "Last 12 Months": "Month"
  }
  return x_axis_labels[store.getters.timePeriod]
}

export function yAxisLabel () {
  var y_axis_labels = {
    "Total Redemptions": "Redemptions",
    "New Redemptions": "Redemptions",
    "Returning Redemptions": "Redemptions",
    "Profile Clicks": "Clicks",
    "Brand Impressions": "Impressions"
  }
  return y_axis_labels[store.getters.countType]
}

export function dataSetLength () {
  return store.getters.graphData.data_set_length
}

export function dataSetCounts () {
  return store.getters.graphData.counts
}

export function tickJump () {
  return store.getters.graphData['tick_jump']
}

function timeJump () {
  return store.getters.graphData['time_jump']
}

function startDateObject () {
  return store.getters.graphData['start_date']
}

export function startDate () {
  var start_date_object = startDateObject()
  return new Date(start_date_object['year'], start_date_object['month'], start_date_object['day'])
}

function endDateObject () {
  return store.getters.graphData['end_date']
}

export function endDate () {
  var end_date_object = endDateObject()
  return new Date(end_date_object['year'], end_date_object['month'], end_date_object['day'])
}

export function tickDates () {
  var end_date = endDate()
  end_date.setDate(endDate().getDate() + timeJump());
  var tick_dates = []
  if (tickJump() === 'month') {
    var year = startDateObject()['year'];
    var start_month = startDateObject()['month'];
    for (var i = 0; i < dataSetLength(); i++) {
      tick_dates.push(new Date(year, start_month + i, 1))
    }
  } else {
    tick_dates = d3.timeDay.range(startDate(), end_date, tickJump()).map(function(d){ return new Date(d) })
  }
  return tick_dates
}

export function dataLabelDates () {
  if ((tickJump() === 'month') || (tickJump() === timeJump())) {
    return tickDates();
  } else {
    var end_date = endDate()
    end_date.setDate(endDate().getDate() + timeJump());
    return d3.timeDay.range(startDate(), end_date, timeJump()).map(function(d){ return new Date(d) });
  }
}

export function tickTimeFormat () {
  var div_container_element = document.getElementById("chart-container")
  var width = Math.max(div_container_element.offsetWidth, 300)
  if (tickJump() === 'month') {
    if (width > 750) {
      return "%b '%y"
    } else {
      return "%b"
    }
  } else {
    if (width > 600) {
      return "%a %-m/%-d"
    } else if (width > 400) {
      return "%-m/%-d"
    } else {
      return "%a"
    }
  }
}

export function tickDateLabelFormat () {
  if (tickJump() === 'month') {
    return "%b '%y"
  } else {
    return "%a %-m/%-d"
  }
}

export function tickSize () {
  if (tickJump() === 'month') {
    return 0
  } else {
    return 6
  }
}

export function gridDataSet () {
  var grid_dataset = [];
  var dataset_length = dataSetLength()

  for (var i = 0; i < 6; i++) {
    grid_dataset.push({
      x1: 1,
      y1: i / 5,
      x2: dataset_length,
      y2: i / 5
    })
  }

  // for (i = 1; i <= dataset_length; i++) {
  //   grid_dataset.push({
  //     x1: i,
  //     y1: 0,
  //     x2: i,
  //     y2: 1
  //   })
  // }
  return grid_dataset
}

export function scaleMax () {
  var max = d3.max(dataSetCounts(), function(d) { return d; });
  var scale_max = max;

  while ((scale_max % 5) != 0) {
    scale_max += 1;
  }

  return scale_max
}
